import { useCallback, useContext } from 'react';
import { isOperatorIncludesObjectsWithNoValueSet, shouldOperatorAlwaysShowNoValueCheckbox } from 'customer-data-filters-ui/utils/defaultNullValue';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
import getConditionId from '../utils/getConditionId';
export const makeConditionHashKey = (condition, conditionPath) => {
  return [getConditionId(conditionPath), condition.field.name, condition.constructor].join('_');
};
const shouldShowNullValueCheckbox = (filterFamily, operator) => {
  const hasValue = typeof operator.value !== 'undefined' || typeof operator.numberOfDays !== 'undefined';
  return hasValue && isOperatorIncludesObjectsWithNoValueSet(operator) || shouldOperatorAlwaysShowNoValueCheckbox(filterFamily, operator);
};
export const useNullValueState = (filterFamily, condition, conditionPath) => {
  const {
    nullValueState,
    dispatch
  } = useContext(SegmentationFiltersInstanceContext);
  const updateNullValueState = useCallback(() => {
    const newNullValueState = Object.assign({}, nullValueState);
    const conditionHashKey = makeConditionHashKey(condition, conditionPath);
    const cachedShowIncludeObjectsWithNoValueSet = nullValueState.showIncludeObjectsWithNoValueSetByOperator[conditionHashKey];
    const newShouldShowNullValueCheckbox = shouldShowNullValueCheckbox(filterFamily, condition);
    const isNullValueChangedFromFalseToTrue = cachedShowIncludeObjectsWithNoValueSet === false && newShouldShowNullValueCheckbox === true;
    if (cachedShowIncludeObjectsWithNoValueSet === undefined || isNullValueChangedFromFalseToTrue) {
      newNullValueState.showIncludeObjectsWithNoValueSetByOperator = Object.assign({}, newNullValueState.showIncludeObjectsWithNoValueSetByOperator, {
        [conditionHashKey]: newShouldShowNullValueCheckbox
      });
      newNullValueState.defaultNullValueByOperator = Object.assign({}, newNullValueState.defaultNullValueByOperator, {
        [conditionHashKey]: condition.defaultNullValue
      });
      dispatch({
        type: 'nullValueState',
        payload: newNullValueState
      });
    }
  }, [condition, dispatch, conditionPath, filterFamily, nullValueState]);
  const getShowNoValueCheckbox = useCallback(() => {
    return nullValueState.showIncludeObjectsWithNoValueSetByOperator[makeConditionHashKey(condition, conditionPath)];
  }, [condition, conditionPath, nullValueState.showIncludeObjectsWithNoValueSetByOperator]);
  return {
    getShowNoValueCheckbox,
    updateNullValueState
  };
};